import * as React from "react";

import { QuestionnaireConsentTabGetDto } from "@common/dto/questionnaire/consent-tab";

import { ConsentProps } from "./consent.types";
import { useConsentController } from "./consent.controller";
import { Header } from "./components/header/header";
import { Page } from "./components/page";

import "./consent.styles.scss";

export const Consent: React.FC<ConsentProps> = (props) => {
  const {
    currentEditingPage,
    handleFieldChange,
  } = useConsentController(props);

  const {
    showConfirmMessage,
    getFields,
    getFolders,
    scrollParentToTop,
    showErrorMessage,
    getFhq4QuestionnaireField,
    errors,
  } = props;


  return (
    <div className="FhqDesignTool-consent">
      <Header
        questionnaire={props.questionnaire}
        onConsentEnable={(enabled) => {
          if (!currentEditingPage.page) return;
          handleFieldChange({page: {...currentEditingPage.page,enabled}})}}
          onLabelChange={(title) => {
          if (!currentEditingPage.page) return;
          handleFieldChange({page: {...currentEditingPage.page,title}})}}
        labelValue={currentEditingPage.page?.title ?? ""}
        consentEnabled={currentEditingPage.enabled}
        errors={errors}
      />

      {currentEditingPage.enabled && props.questionnaire.consentTab.page?.id && (
        <Page
          getFhq4QuestionnaireField={getFhq4QuestionnaireField}
          errors={errors}
          showErrorMessage={showErrorMessage}
          scrollParentToTop={scrollParentToTop}
          getFields={getFields}
          getFolders={getFolders}
          showConfirmMessage={showConfirmMessage}
          cachedData={currentEditingPage as QuestionnaireConsentTabGetDto}
          onChange={handleFieldChange}
          questionnaireId={props.questionnaire.questionnaireId}
          consentPageNumber={props.questionnaire.consentTab.page?.id}
        />
      )}
    </div>
  );
};